<template>
    <div class="form-group">

        <select class="form-control border border-dark" v-model="selectedItem" :disabled="isDisabled">
            <option v-if="oldValue === null || nullOption " value="null">Please select {{ selectName }}</option>

            <optgroup v-for="(category, idx) in items" :label="idx" :key="idx">
                <option v-for="(item, idx) in category" :key="idx" :value="item">
                    {{ item.name }}
                </option>
            </optgroup>
        </select>

        <input type="hidden" :name="selectName + '_id'" :value="selectedItem.id">
        <input type="hidden" :name="selectName + '_type'" :value="selectedItem.model">

    </div>
</template>

<script>
export default {
    props: {

        selectName: {
            type: String,
            required: true
        },

        items: {
            type: Object,
            default: {}
        },

        oldValue: {
            type: Object,
            default: null,
        },

        required: {
            type: Boolean,
            default: false,
        },

        isDisabled: {
            type: Boolean,
            default: false
        },

        nullOption: {
            type: Boolean,
            default: false
        }

    },

    data() {
        return {
            selectedItem: '-',
        };
    },

    mounted() {
        let seekObject = (
            (this.oldValue != null) ?
            { id: this.oldValue[this.selectName + "_id"], model: this.oldValue[this.selectName + "_type"] } :
            { id: 0, model: "Nonexistent" }
        );

        this.findPreSelected(seekObject);
    },

    methods: {

        findPreSelected(seekObject) {
            for (let keyWordIndex in this.items) {
                if (this.items[keyWordIndex][0].model !== seekObject.model) continue;

                for (let element of this.items[keyWordIndex]) {
                    if (element.id === seekObject.id) {
                        this.selectedItem = element;
                        break;
                    }
                }
            }
        },

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/measurements-module/MorphedTypeSelect.vue